export default __webpack_public_path__ + "static/media/pack-1.ba00d1f8.png";